import type { TableData } from '../types/api/tables';

/**
 * Quick Access Table - Optimized table access with primary key indexing
 */
export class QuickAccessTable {
  private primaryIndex: Map<any, number>;
  private data: TableData;
  
  constructor(data: TableData) {
    this.data = data;
    this.primaryIndex = new Map();
    
    // Build primary key index
    const pkIndex = data.Schema.findIndex(c => c.Name === data.PrimaryKey);
    data.Data.Rows?.forEach((row, idx) => {
      this.primaryIndex.set(row[pkIndex], idx);
    });
  }
  
  get(primaryKey: any): Record<string, any> | null {
    const index = this.primaryIndex.get(primaryKey);
    if (index === undefined) return null;
    
    const row = this.data.Data.Rows[index];
    const obj: Record<string, any> = {};
    this.data.Data.Columns.forEach((col, idx) => {
      obj[col] = row[idx];
    });
    return obj;
  }

  get size(): number {
    return this.data.Data.Rows.length;
  }

  getAllKeys(): any[] {
    return Array.from(this.primaryIndex.keys());
  }

  has(primaryKey: any): boolean {
    return this.primaryIndex.has(primaryKey);
  }
}

/**
 * Create memory-optimized table access
 * Efficient memory storage helper function
 */
export function toMemoryOptimized(dto: TableData): QuickAccessTable {
  return new QuickAccessTable(dto);
}
